import { find, get, minBy, sortBy, uniqBy } from 'lodash';
import { toTrimGroups, toUniqueTrims } from '../../steps/config/trims/utils';

export const buildDriveOptions = (options, driveTypes) => {
  const driveOptions = options.map((option) => {
    const { driveType, rearWheelType } = option;
    const { lowestMsrp, label } = find(driveTypes, { id: driveType });
    return {
      id: `${driveType}-${rearWheelType}`,
      driveType,
      rearWheelType,
      description: option.driveTypeDescription,
      msrp: lowestMsrp?.amount?.value,
      label: label,
    };
  });

  const uniqueDriveOptions = uniqBy(driveOptions, 'id');
  return sortBy(uniqueDriveOptions, 'msrp');
};

export const getLowestPricedTrims = (trimGroups) => {
  return trimGroups.map((trimGroup) => {
    return {
      cgiTransparent: trimGroup.cgiTransparent,
      ...(minBy(trimGroup.options, 'msrp') || {}),
    };
  });
};

export const getHeaderDataForStyle = (style, msrpKey = 'msrp') => {
  if (!style) {
    return null;
  }
  return {
    primaryText: style.trimName,
    msrp: style[msrpKey] || style.message,
    imageUrl: style.cgiTransparent,
    trimKey: style.trimName,
  };
};

export const getFilteredOptions = (
  normalizedOptions,
  selectedDriveType,
  selectedOption
) =>
  normalizedOptions.filter((option) => {
    let keepOption = true;
    if (selectedDriveType) {
      keepOption =
        keepOption &&
        option.driveType === selectedDriveType.driveType &&
        option.rearWheelType === selectedDriveType.rearWheelType;
    }

    if (selectedOption) {
      keepOption =
        keepOption && option.bodyTypeName === selectedOption.bodyTypeName;
    }

    return keepOption;
  });

export const getFilteredTrims = (filteredOptions, config) => {
  const trims = toUniqueTrims(filteredOptions);
  const trimGroups = toTrimGroups(trims, filteredOptions, config.styles);
  return getLowestPricedTrims(trimGroups);
};

export const setDefaultTrimIndex = (trims, targetTrim) => {
  const indexFound = trims.findIndex((trim) => trim.trimName === targetTrim);
  if (indexFound > -1) {
    return indexFound;
  }
  return 0;
};

export const combineWithEngine = (config, options) => (matrix) =>
  matrix.reduce((accum, matrixItem) => {
    const optionData = find(options, { styleId: `${matrixItem.styleId}` });
    if (optionData) {
      const engineDescription = get(
        find(config.engines, { code: matrixItem.engine }),
        'description'
      );
      return [
        ...accum,
        {
          ...matrixItem,
          ...optionData,
          engineDescription,
        },
      ];
    }
    return accum;
  }, []);

export const getFirstValidIndex = (arr) => {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] && arr[i].length > 0) {
      return i;
    }
  }

  return -1;
};

export const getAppPath = (currentPath) =>
  currentPath.substr(
    0,
    currentPath.lastIndexOf('/', currentPath.lastIndexOf('/') - 1)
  );
